import { projects } from "../data/portfolio";
import "../styles/Portfolio.css";

const ProjectsSection = () => {
  return (
    <section id="projects" className="portfolio-section">
      <div className="portfolio-container">
        <h2 className="section-label">Projects</h2>
        <div className="card-grid projects-grid">
          {projects.map((project, index) => (
            <a
              key={index}
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`card project-card ${!project.url ? "no-link" : ""}`}
            >
              {project.image && (
                <div className="project-image">
                  <img src={project.image} alt={project.name} />
                </div>
              )}
              <div className="project-content">
                <h3 className="card-title">{project.name}</h3>
                <p className="card-subtitle">{project.description}</p>
                {project.tags && (
                  <div className="project-tags">
                    {project.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="project-tag">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
